import {FormWrapperMinimum} from "@twigsby/frontend-framework";
import {useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";

type RulesetNameType = {
    name: string;
}

const RulesetName = (props: RulesetNameType) => {
    const { register, getValues, formState } = useFormContext();

    return (
        <FormWrapperMinimum
            invalid={formState.errors[props.name]}
            validationMessage={formState.errors[props.name]?.message as string}
        >
            <input
                type={"text"}
                className={'thing-input'}
                placeholder={'Name...'}
                defaultValue={getValues(props.name)}
                {...register(props.name, { required: "Name is required" })}
            />
        </FormWrapperMinimum>
    )
}

export { RulesetName }
